import React from 'react';
import { Modal, Button, Row, Col, Radio } from 'react-bootstrap';
import { Label } from 'fw/components';
import { TextBox, Combo } from 'fw/forms';
import * as API from 'modules/app/API';
import * as Notifications from 'fw/globals/Notifications';

class DenialCodesPopUp extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            denialCodes: [],
            denialCode1Id: null,
            denialCode2Id: null,
            denialCode3Id: null,
            applicationDays: 0,
            isRefunded: null
        };
    }

    componentDidMount() {
        this.loadDenialCodes();
    }

    componentDidUpdate(prevProps) {
        if (this.props.visible && !prevProps.visible) {
            this.loadApplicationDays();
            this.setState({
                denialCode1Id: null,
                denialCode2Id: null,
                denialCode3Id: null,
                isRefunded: null
            });
        }
    }

    loadDenialCodes = () => {
        API.App.get('/DenialCodeSetup/getLookup', {}, {
            success: (r) => {
                const options = r.data.items.map(item => ({
                    value: item.value,
                    label: item.label
                }));
                this.setState({ denialCodes: options });
            },
            error: (r) => {
                Notifications.error('Failed to load denial codes');
            }
        });
    }

    loadApplicationDays = () => {
        const { certificationId } = this.props;
        if (!certificationId) return;

        API.App.get('/DenialCodeSetup/getApplicationDays', { certificationId }, {
            success: (r) => {
                this.setState({ applicationDays: r.data.applicationDays || 0 });
            },
            error: (r) => {
                Notifications.error('Failed to load application days');
            }
        });
    }

    handleDenialCode1Change = (item) => {
        this.setState({ denialCode1Id: item ? item.value : null });
    }

    handleDenialCode2Change = (item) => {
        this.setState({ denialCode2Id: item ? item.value : null });
    }

    handleDenialCode3Change = (item) => {
        this.setState({ denialCode3Id: item ? item.value : null });
    }

    handleApplicationDaysChange = (value) => {
        this.setState({ applicationDays: parseInt(value, 10) || 0 });
    }

    handleRefundChange = (e) => {
        this.setState({ isRefunded: e.target.value === 'refunded' });
    }

    handleSave = () => {
        const { denialCode1Id, denialCode2Id, denialCode3Id, applicationDays, isRefunded } = this.state;

        // Validation
        if (!denialCode1Id || !denialCode2Id || !denialCode3Id) {
            Notifications.error('Please select all 3 denial codes');
            return;
        }

        // Check that all 3 denial codes are different
        if (denialCode1Id === denialCode2Id || denialCode1Id === denialCode3Id || denialCode2Id === denialCode3Id) {
            Notifications.error('Please select 3 different denial codes');
            return;
        }

        if (isRefunded === null) {
            Notifications.error('Please select a refund option');
            return;
        }

        this.props.onSave({
            denialCode1Id,
            denialCode2Id,
            denialCode3Id,
            applicationDays,
            isRefunded
        });
    }

    render() {
        const { denialCodes, denialCode1Id, denialCode2Id, denialCode3Id, applicationDays, isRefunded } = this.state;

        return (
            <Modal show={this.props.visible} onHide={this.props.onCancel}>
                <Modal.Header>
                    <Modal.Title>Denial Codes</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Row>
                        <Col md={2}>
                            <Label required>DC1</Label>
                        </Col>
                        <Col md={10}>
                            <Combo
                                value={denialCode1Id}
                                onChange={this.handleDenialCode1Change}
                                items={denialCodes}
                                placeholder="Select denial code..."
                                clearable
                            />
                        </Col>
                    </Row>
                    <br />
                    <Row>
                        <Col md={2}>
                            <Label required>DC2</Label>
                        </Col>
                        <Col md={10}>
                            <Combo
                                value={denialCode2Id}
                                onChange={this.handleDenialCode2Change}
                                items={denialCodes}
                                placeholder="Select denial code..."
                                clearable
                            />
                        </Col>
                    </Row>
                    <br />
                    <Row>
                        <Col md={2}>
                            <Label required>DC3</Label>
                        </Col>
                        <Col md={10}>
                            <Combo
                                value={denialCode3Id}
                                onChange={this.handleDenialCode3Change}
                                items={denialCodes}
                                placeholder="Select denial code..."
                                clearable
                            />
                        </Col>
                    </Row>
                    <br />
                    <Row>
                        <Col md={2}>
                            <Label>C2D</Label>
                        </Col>
                        <Col md={3}>
                            <TextBox
                                value={applicationDays}
                                onChange={this.handleApplicationDaysChange}
                            />
                        </Col>
                        <Col md={7}>
                            <span style={{ lineHeight: '34px', marginLeft: '-20px'  }}>Application Days</span>
                        </Col>
                    </Row>
                    <br />
                    <Row>
                        <Col md={2}>
                            <Label required>Refund</Label>
                        </Col>
                        <Col md={3} style={{ marginTop: '-10px' }}>
                            <Radio
                                name="refundOption"
                                value="noRefund"
                                checked={isRefunded === false}
                                onChange={this.handleRefundChange}
                            >
                                No Refund
                            </Radio>
                        </Col>
                        <Col md={7} style={{ marginTop: '-10px', marginLeft: '-45px' }}>
                            <Radio
                                name="refundOption"
                                value="refunded"
                                checked={isRefunded === true}
                                onChange={this.handleRefundChange}
                            >
                                Fee Refunded
                            </Radio>
                        </Col>
                    </Row>
                </Modal.Body>
                <Modal.Footer>
                    <Button bsStyle="primary" onClick={this.handleSave}>Save</Button>
                    <Button onClick={this.props.onCancel}>Cancel</Button>
                </Modal.Footer>
            </Modal>
        );
    }
}

export default DenialCodesPopUp;



// WEBPACK FOOTER //
// ./src/areas/admin/certification/shared/DenialCodesPopUp.js